import {defineStore} from 'pinia'
import {IContact} from "@/interface/services/response/contact.interface";

export const useContactStore = defineStore('contact', {
    state: (): IContactState => ({
        id: 0,
        language: 'fr',
        civility: null,
        firstName: null,
        lastName: null,
        birthDate: null,
        nationality: null,
        phone: null,
        mobile: null,
        email: null,
        isEmailConfirmed: true,
        isResidential: true,
        companyName: null,
        companyType: null,
        companyNumber: null,
        companyVat: null
    }),
    actions: {
        initStoreWithValue(contact: IContact) {
            this.id = contact.id
            this.language = contact.language
            this.firstName = contact.firstName
            this.lastName = contact.lastName
            this.birthDate = contact.birthDate
            this.nationality = contact.nationality
            this.phone = contact.phone
            this.mobile = contact.mobile
            this.email = contact.email
            this.civility = contact.civility
            this.isEmailConfirmed = contact.isEmailConfirmed
            this.isResidential = !!(contact.isResidential && contact.isResidential == 1)
            if (contact.company) {
                this.companyName = contact.company.name
                this.companyType = contact.company.type
                this.companyNumber = contact.company.number
                this.companyVat = contact.company.vatNumber
            } else {
                this.resetCompanyInformation()
            }
        },
        resetCompanyInformation() {
            this.companyName = null
            this.companyType = null
            this.companyNumber = null
            this.companyVat = null
        }
    },
    getters: {
        firstLastName(state: IContactState) : string|null {
            const value = (this.firstName ? this.firstName + ' ' : '') + (this.lastName ?? '')
            if (value == '') {
                return null
            }

            return value
        },
        lastFirstName(state: IContactState) : string|null {
            const value = (this.lastName ? this.lastName + ' ' : '') + (this.firstName ?? '')
            if (value == '') {
                return null
            }

            return value
        },
    },
    persist: true,
})

interface IContactState {
    id: number,
    language: string|null,
    civility: string|null,
    firstName: string|null,
    lastName: string|null,
    birthDate: string|null,
    nationality: string|null,
    phone: string|null,
    mobile: string|null,
    email: string|null,
    isEmailConfirmed: boolean,
    isResidential: boolean,
    companyName: string|null,
    companyType: string|null,
    companyNumber: string|null,
    companyVat: string|null
}

export type ContactStore = ReturnType<typeof useContactStore>